import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {PagerTitle} from '../../../global';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { NgFor } from '@angular/common';
import { AccessDirective } from '../../directives/has-access.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'slm-tabs',
    template: `
    <nav mat-tab-nav-bar #slmMatTabs [tabPanel]="tabPanel">
      <ng-container *ngFor="let tab of tabs; index as index">
        <ng-container *slmAccess="tab.rights">
          <a
            mat-tab-link
            [attr.data-test-id]="tab.testId"
            (click)="goTo.emit(tab.route)"
            (keyup.enter)="goTo.emit(tab.route)"
            [active]="(tab.route === selected) || (index === 0 && !selected)"
          >
            {{ tab.title | translate }}
          </a>
        </ng-container>
      </ng-container>
    </nav>
    <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>

  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatTabNav, NgFor, AccessDirective, MatTabLink, MatTabNavPanel, TranslatePipe]
})
export class TabsComponent {
  @Input() tabs: Array<PagerTitle> = [];
  @Input() selected = '';
  @Output() goTo = new EventEmitter<string>();
}
